<div class="container">
    <div class="row">
        <div class="col-12">
            <div class="job-search-field">
                <div class="job-search-item">
                    <div class="form row">
                        <div class="col-lg-5">
                            <div class="form-group left-icon">
                                <input type="text" class="form-control" [(ngModel)]="skillKeyword" placeholder="What?">
                                <i class="fas fa-search"></i>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="form-group left-icon">
                                <input type="text" class="form-control" [(ngModel)]="location" placeholder="Where?">
                                <i class="fas fa-search"></i>
                            </div>
                        </div>
                        <div class="col-lg-2 col-sm-12">
                            <div class="form-group form-action">
                                <button type="button" class="btn btn-primary mt-0" (click)="filterCandidates()"><i
                                        class="fas fa-search-location"></i>Find Candidates</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>